import React from "react";
import DmeTag from "@/components/DmeTag";

export const POS_COLORS = { QB: "#0284C7", RB: "#16A34A", WR: "#7C3AED", TE: "#D97706", PICK: "#2563EB" };

export function ordinal(n) {
  const s = ["th", "st", "nd", "rd"], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export function Stat({ label, value, sub, dme }) {
  return (
    <div className="card-bordered p-5">
      <div className="text-[10px] tracking-[0.2em] text-[var(--text-3)] font-mono flex items-center gap-1.5">{label}{dme && <DmeTag />}</div>
      <div className="font-mono text-3xl font-bold mt-1">{value}</div>
      {sub && <div className="text-xs text-[var(--text-2)] mt-1">{sub}</div>}
    </div>
  );
}
